/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Recent_RunsInputs */

const cs_pm_recent_runs = /** @type {(inputs: Pm_Recent_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední běhy`)
};

const en_pm_recent_runs = /** @type {(inputs: Pm_Recent_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent runs`)
};

/**
* | output |
* | --- |
* | "Recent runs" |
*
* @param {Pm_Recent_RunsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_recent_runs = /** @type {((inputs?: Pm_Recent_RunsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Recent_RunsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_recent_runs(inputs)
	return cs_pm_recent_runs(inputs)
});